import { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import {
  GetInvitationByInvitationId,
  UpdateInvitation,
} from "../../services/InvitationService";
import { GetUserByPhoneNumber } from "../../services/AccountService";
import {
  DeletePositionByUserIdAndAddNewPosition,
  GetPositionByUserId,
} from "../../services/PositionService";
import { Button } from "@mui/material";

const InvitationRequest = () => {
  const setActiveIndex = useOutletContext();
  const [getInvitation, setInvitation] = useState<any>(null);
  const [getUser, setUser] = useState<any>(null);
  const [getPosition, SetPosition] = useState<any>(null);
  const params = useParams();
  const navigate = useNavigate();
  async function GetInvitationByInvitationIdAsync() {
    await GetInvitationByInvitationId(params.id).then((p) => {
      console.log(p.data.data);
      if (p.data.data === undefined || p.data.data === null) {
        navigate("/InvitationNotFound");
      }
      setInvitation(p.data.data);
    });
  }

  async function GetUserByPhoneNumberAsync(phoneNumber: string) {
    await GetUserByPhoneNumber(phoneNumber).then((p) => {
      setUser(p.data.data);
    });
  }

  async function GetPositionByUserIdAsync(userId: string) {
    await GetPositionByUserId(userId).then((p) => {
      console.log("lp", p);

      SetPosition(p.data);
    });
  }
  async function UpdateInvitationAsync(state: number) {
    if (params.id) {
      await UpdateInvitation({
        invitationId: params.id,
        invitationState: state,
      }).then(() => navigate("/"));
    }
  }

  async function DeletePositionByUserIdAndAddNewPositionAsync() {
    //    console.log(getInvitation.positionId);
    //console.log(getUser.id);

    await DeletePositionByUserIdAndAddNewPosition({
      userId: getUser.id,
      positionId: getInvitation.positionId,
    }).then(() => {
      navigate("/");
    });
  }
  useEffect(() => {
    (setActiveIndex as any)(2);
    GetInvitationByInvitationIdAsync();
  }, []);

  useEffect(() => {
    if (getInvitation) {
      GetUserByPhoneNumberAsync(getInvitation.phoneNumber);
    }
  }, [getInvitation]);

  useEffect(() => {
    if (getUser) {
      GetPositionByUserIdAsync(getUser.id);
    }
  }, [getUser]);

  return (
    <>
      <div className="container mt-5 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
        <ul
          className="iran"
          style={{ textDecoration: "none", listStyle: "none" }}
        >
          <li>
            نام :<b>{getInvitation?.firstName}</b>
          </li>
          <li>
            نام خانوادگی :<b>{getInvitation?.lastName}</b>
          </li>
          <li>
            سمت:<b>{getInvitation?.position?.name}</b>
          </li>
          <li>
            فروشگاه دعوت کننده:<b>{getInvitation?.company?.name}</b>
          </li>
        </ul>
        <div
          style={{
            display:
              getPosition !== null &&
              getPosition !== "" &&
              getPosition !== undefined
                ? "block"
                : "none",
          }}
        >
          <p style={{ color: "maroon" }}>
            کاربر گرامی، شما در آن واحد در سامانه سیسد میتوانید تنها یک سمت در
            یک فروشگاه داشته باشید. با قبول سمت فعلی، شما از سمت قبلی خود ({" "}
            <b>{getPosition?.name}</b>) در فروشگاه{" "}
            <b>{getPosition?.company?.name}</b> خارج خواهید شد.
          </p>
        </div>
        <div>
          <Button
            onClick={() => {
              UpdateInvitationAsync(2);
              DeletePositionByUserIdAndAddNewPositionAsync();
            }}
            className="mx-2 iran"
            style={{}}
            variant="outlined"
            type="button"
            color="success"
          >
            پذیرش
          </Button>
          <Button
            onClick={() => {
              UpdateInvitationAsync(3);
            }}
            className="mx-2 iran"
            style={{}}
            variant="outlined"
            type="button"
            color="error"
          >
            رد
          </Button>
        </div>
      </div>
    </>
  );
};
export default InvitationRequest;
